import styled from 'styled-components';
import { layout, space } from 'styled-system';

const Row = styled.div`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 24px;
  max-width: 100%;
  width: 100%;

  ${layout}
  ${space}

  a, button {
    margin-left: 16px;
  }
`;

export default Row;
